import React from "react";

// SOF-798: single source of truth for how terminated plans are labeled across
// the whole application (builder, comparison, rates, rate model grid).

export const TERMINATED_TOOLTIP =
  "This plan is terminated. It is shown for visual/context only and cannot be selected or edited.";

// Grey used for terminated/read-only text across the app.
export const TERMINATED_COLOR = "#999";

// Generic label used where the carrier/client distinction is not available
// (e.g. the Client Summary termed section, which does not carry a termination type).
export const TERMINATED_GENERIC_LABEL = "[Terminated]";

/**
 * Label text for a termination type.
 * carrier (default) -> "[Terminated By Carrier]"
 * client            -> "[Terminated By Client]"
 */
export const terminationLabel = (terminationType) => {
  const t = (terminationType || "").trim().toLowerCase();
  if (t === "client") return "[Terminated By Client]";
  return "[Terminated By Carrier]";
};

/**
 * Static, greyed label with a tooltip, appended next to a terminated plan name.
 * Pass `plain` to render the generic "[Terminated]" label when the carrier/client
 * distinction is not available on the surface.
 */
export default function TerminatedBadge({ terminationType, plain, style, className }) {
  const label = plain ? TERMINATED_GENERIC_LABEL : terminationLabel(terminationType);
  return (
    <span
      className={className}
      title={TERMINATED_TOOLTIP}
      style={{
        color: TERMINATED_COLOR,
        fontStyle: "italic",
        marginLeft: 6,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {label}
    </span>
  );
}
